import React from "react";

const Buttons = () => {
    return (
        <div className="hide-for-mobile">
            <button className="btn">Request Invite</button>
        </div>
    );
};

export default Buttons;
